import React, { useState, useEffect, useRef } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../css/Global.css'
import CustomTopNavbarButton from './CustomTopNavbarButton';
import { useNavigate, useLocation } from "react-router-dom";
import Axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { Mic, MicOff } from '@mui/icons-material';
import $ from "jquery";
import { decode as base64_decode, encode as base64_encode } from 'base-64';
import Select from 'react-select'
import back from '../mainassets/back.png'
const moment = require('moment');

function TableRows({ rows, tableRowRemove, onValUpdate }) {
    return rows.map((rowsData, index) => {
        const { name, dose, when, frequency, duration } = rowsData;
        return (
            <div style={{ marginTop: 7, marginLeft: -15, width: '110%' }}>
                <tr key={index} >
                    <td style={{ width: '30%' }}
                    >
                        <input
                            type="text"
                            value={name}
                            onChange={(event) => onValUpdate(index, event)}
                            name="name"
                            className="form-control"
                            style={{ fontSize: 12, fontWeight: '500' }}
                        />
                    </td>
                    <td style={{ width: '17%' }}>
                        <input
                            type="text"
                            value={dose}
                            onChange={(event) => onValUpdate(index, event)}
                            name="dose"
                            className="form-control"
                            style={{ fontSize: 12, fontWeight: '500' }}

                        />
                    </td>
                    <td style={{ width: '17%' }} >
                        <input
                            type="text"
                            value={when}
                            onChange={(event) => onValUpdate(index, event)}
                            name="when"
                            className="form-control"
                            style={{ fontSize: 12, fontWeight: '500' }}

                        />
                    </td>
                    <td style={{ width: '15%' }}>
                        <input
                            type="text"
                            value={frequency}
                            onChange={(event) => onValUpdate(index, event)}
                            name="frequency"
                            className="form-control"
                            style={{ fontSize: 12, fontWeight: '500' }}

                        />
                    </td>
                    <td style={{ width: '15%' }}>
                        <input

                            type="text"
                            value={duration}
                            onChange={(event) => onValUpdate(index, event)}
                            name="duration"
                            className="form-control"
                            style={{ fontSize: 12, fontWeight: '500' }}

                        />
                    </td>
                    <td style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }} >
                        <button
                            style={{ fontSize: 30, marginTop: 5, marginLeft: 55 }} className="btn btn-auto btn-xs btn-danger" onClick={() => tableRowRemove(index)}

                        >-
                        </button>
                    </td>
                </tr>
            </div>

        );
    });
}




function TableRowsEyePower({ rows, onValEyePowerUpdate }) {
    const { red_dsph, red_dcyl, red_axis, red_vision, led_dsph, led_dcyl, led_axis, led_vision, ren_dsph, ren_dcyl, ren_axis, ren_vision, len_dsph, len_dcyl, len_axis, len_vision } = rows[0];

    // const { ren_dsph, ren_dcyl, ren_axis, ren_vision, len_dsph, len_dcyl, len_axis, len_vision } = rows[1];


    return (
        <>
            <tr  >
                <td> Distance</td>
                <td>
                    <input
                        type="text"
                        value={red_dsph}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="red_dsph"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                        maxLength={6}

                    />
                </td>
                <td>
                    <input
                        type="text"
                        value={red_dcyl}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="red_dcyl"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                        maxLength={6}

                    />
                </td>
                <td >
                    <input
                        type="text"
                        value={red_axis}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="red_axis"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                        maxLength={6}

                    />
                </td>
                <td >
                    <input
                        maxLength={20}
                        type="text"
                        value={red_vision}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="red_vision"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                    />
                </td>
                <td >
                    <input
                        maxLength={6}
                        type="text"
                        value={led_dsph}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="led_dsph"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                    />
                </td>
                <td >
                    <input
                        maxLength={6}
                        type="text"
                        value={led_dcyl}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="led_dcyl"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                    />
                </td>
                <td >
                    <input
                        maxLength={6}
                        type="text"
                        value={led_axis}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="led_axis"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                    />
                </td>
                <td >
                    <input
                        maxLength={20}
                        type="text"
                        value={led_vision}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="led_vision"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                    />
                </td>

            </tr>

            <tr >
                <td>Near</td>
                <td>
                    <input
                        type="text"
                        value={ren_dsph}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="ren_dsph"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                        maxLength={6}

                    />
                </td>
                <td>
                    <input
                        type="text"
                        value={ren_dcyl}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="ren_dcyl"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                        maxLength={6}

                    />
                </td>
                <td >
                    <input
                        maxLength={6}
                        type="text"
                        value={ren_axis}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="ren_axis"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                    />
                </td>
                <td >
                    <input
                        type="text"
                        value={ren_vision}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="ren_vision"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                        maxLength={20}

                    />
                </td>
                <td >
                    <input
                        type="text"
                        value={len_dsph}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="len_dsph"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                        maxLength={6}

                    />
                </td>
                <td >
                    <input
                        type="text"
                        value={len_dcyl}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="len_dcyl"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                        maxLength={6}

                    />
                </td>
                <td >
                    <input
                        type="text"
                        value={len_axis}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="len_axis"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                        maxLength={6}

                    />
                </td>
                <td >
                    <input
                        type="text"
                        value={len_vision}
                        onChange={(event) => onValEyePowerUpdate(0, event)}
                        name="len_vision"
                        className="form-control"
                        style={{ fontSize: 12, fontWeight: 'bold' }}
                        maxLength={20}

                    />
                </td>

            </tr>
        </>
    )
    // </div>


}



export default () => {
    const location = useLocation();
    const navigate = useNavigate();
    const recognitionL = new window.webkitSpeechRecognition();
    const recognitionF = new window.webkitSpeechRecognition();
    const [consultationId, setConsultationId] = useState("");

    const [precriptionType, setPrecriptionType] = useState([]);
    const [precriptionName, setPrecriptionName] = useState("DigitalConsultationV3");
    const [showDate, setShowDate] = useState("");
    const [nextVisit, setNextVisit] = useState("");
    const [cancelConsultationModalOpen, setCancelConsultationModalOpen] = useState(false);
    const [chief_complaints, setChief_complaints] = useState("");
    const [medicalSearch, setMedicalSearch] = useState('')
    const [testMed, setTestMed] = useState("");
    const [doctorfindings, setDoctorFindings] = useState("");
    const [pid, setPid] = useState("");
    const [doctor_notes, setDoctor_notes] = useState("");
    const [notes, setNotes] = useState("");
    const [medName, setMedName] = useState("");
    const [docId, setDocId] = useState("");
    const [patientemail, setPatientEmail] = useState("");
    const [msg, setMsg] = useState("");
    const [locationObject, setLoctionObject] = useState({});
    const [isButtonHide, setIsButtonHide] = useState(false);
    const [cancelling, setCancelling] = useState(false);
    const [medicineTableRows, setMedicineTableRows] = useState([]);
    const [eyePowerTableRows, setEyePowerTableRows] = useState([{ red_dsph: "", red_dcyl: "", red_axis: "", red_vision: "", led_dsph: "", led_dcyl: "", led_axis: "", led_vision: "", ren_dsph: "", ren_dcyl: "", ren_axis: "", ren_vision: "", len_dsph: "", len_dcyl: "", len_axis: "", len_vision: "" }]);
    const [eyePowerTableRows1, setEyePowerTableRows1] = useState([{ ren_dsph: "", ren_dcyl: "", ren_axis: "", ren_vision: "", len_dsph: "", len_dcyl: "", len_axis: "", len_vision: "" }]);
    const [medicineTableArray, setMedicineTableArray] = useState([]);
    const [eyePowerTableArray, setEyePowerTableArray] = useState([]);
    const [micMedicine, setMicMedicine] = useState(false)
    const [suggestionList, setSuggestionList] = useState([])
    const [micLab, setMicLab] = useState(false)
    const [investigationSearch, setInvestigationSearch] = useState('')
    const [investigationList, setInvestigationList] = useState([])
    const [micFindingsValue, setMicFindingsValue] = useState("");
    const [adviceDoes, setAdviceDoes] = useState("");
    const [adviceDonts, setAdviceDonts] = useState("");
    const [adviceDoesList, setAdviceDoesList] = useState([]);
    const [adviceDontsList, setAdviceDontsList] = useState([]);
    const [consultationModalOpen, setConsultationModalOpen] = useState(false);
    const [showPleaseWait, setShowPleaseWait] = useState(false);
    const [ConsultationDate, setConsultationDate] = useState("");
    const [serviceList, setServiceList] = useState([]);
    const [servicetype, setServiceType] = useState("");
    const [consultService, setConsultService] = useState("");
    const [ConsultationServiceList, setConsultationServiceList] = useState([]);
    const [isEmptymptyServiceList, setIsEmptyServiceList] = useState(false);
    const [isShowServiceDropDown, setIsShowServiceDropDown] = useState(false);
    const [isChooseServiceType, setIsChooseServiceType] = useState(false);
    const [forwardModalOpen, setForwardModalOpen] = useState(false);
    const [procedureList, setProcedureList] = useState([]);
    const [procedure, setProcedure] = useState("");
    const procedureCount = useRef(0)
    const currentdate = new Date().toLocaleDateString('en-GB');
    const [selectedProcedure, setSelectedProcedure] = useState([]);
    console.log("procedureArray", JSON.stringify(selectedProcedure));
    const adviceDoesCount = useRef(0)
    const adviceDontsCount = useRef(0)
    const investigationCount = useRef(0)


    const handleChangeProcedureList = (values) => {
        procedureCount.current = procedureCount.current + 1

        setSelectedProcedure(values || []);
        console.log(".......", values);
        setProcedure(values?.map((list) => ({
            value: list.label,

        })))

    };

    const handleCloseCancelConsultation = (e) => {
        setCancelConsultationModalOpen(false);


    }
    const testMedHandler = (e) => {

        setTestMed(e.target.value);

    }
    const adviceDontsHandler = (e) => {
        setAdviceDonts(e.target.value);

    }
    const onAdviceDoesUpdate = (e) => {
        // setAdviceDoes(e.target.value);
        adviceDoesCount.current = adviceDoesCount.current + 1
        const old = adviceDoes
        setInvestigationSearch('')
        setAdviceDoes(old + adviceDoesCount.current + ':) ' + e.target.value + '\n')
        // setAdviceDoesList([]);

    }

    const adviceDoesHandler = (e) => {
        setAdviceDoes(e.target.value);

    }

    const serviceUpdateHandler = (e) => {
        setConsultService(e.target.value);
        console.log(e.target.value)

    }
    const serviceTypeUpdateHandler = (e) => {
        console.log(e.target.value)
        setServiceType(e.target.value);
        if (e.target.value != "") {
            setIsChooseServiceType(true);

        } else {
            setIsChooseServiceType(false);
        }
        Axios.get(`${global.baseUrl}/api/clinicapi/FeeMaster/get_services_list?serviceType=${e.target.value}&clinicId=${localStorage.getItem("clinic_id")}`).then((response) => {
            console.log(response.data.response);
            if (response.data.response.length > 0) {
                setConsultationServiceList(response.data.response);
                setIsEmptyServiceList(false);
                setIsShowServiceDropDown(true);

            }
            else {
                setIsEmptyServiceList(true);
                setIsShowServiceDropDown(false);

            }



        });

    }

    const addServiceHandler = (e) => {
        e.preventDefault();

        setIsButtonHide(true);
        e.preventDefault();

        let formdata = $(e.target);
        formdata = new FormData();

        formdata.append('clinic_id', localStorage.getItem("clinic_id"));
        formdata.append('service_id', consultService);
        formdata.append('consultation_id_fk', location.state.state.id);

        $.ajax({
            type: "POST",
            url: `${global.baseUrl}/api/clinicapi/FeeMaster/add_consultation_service`,
            data: formdata,
            processData: false,
            contentType: false,
            success(data) {
                console.log("service data=  ", data);
                setForwardModalOpen(false);
                navigate("/Consultation")

            },
            error: function (err) {
                console.log(err.responseText);
                alert("error has occured  ", err);
            }
        });



    }


    recognitionL.onresult = (event) => {
        console.log("listening");

        const value = event.results[0][0].transcript
        setInvestigationHandler(value)
        console.log(value)

        //  setRecognizedText(event.results[0][0].transcript);
    };
    recognitionF.onresult = (event) => {
        console.log("listening");
        const value = event.results[0][0].transcript
        console.log("listening =", value)
        setDoctorFindingsHandler(value);
        setMicFindingsValue(value);
        setDoctorFindings(value)
        //  setRecognizedText(event.results[0][0].transcript);
    };


    const setDoctorFindingsHandler = async (value) => {

        // setDoctor_notes(value);
        setDoctorFindings(value);
    }
    const setInvestigationHandler = async (value) => {
        setInvestigationSearch(value)
        if (value === '' || value.length < 2) {
            setInvestigationList([])
            return
        }
        try {
            const response = await Axios.get(`${global.baseUrl}/api/commonapi/PickList/get_diagnostictest?name=${value}`)
            console.log(response)
            if (response.data.status == '1') {
                setInvestigationList(response.data.response)
            }

        } catch (error) {
            console.log(error)
        }
    }

    const setMedicineSearchHandler = async (value) => {
        setMedicalSearch(value);
        if (value === '' || value.length < 2) {
            setSuggestionList([])
            return
        }
        try {
            const response = await Axios.get(`${global.baseUrl}/api/commonapi/PickList/get_medicine_details?name=${value}`)
            if (response.data.status == '1') {
                setSuggestionList(response.data.response)
            }

        } catch (error) {
            console.log(error)
        }

    }

    const {
        transcript,
        listening,
        resetTranscript1,
        browserSupportsSpeechRecognition1
    } = useSpeechRecognition();
    const nextVisitHandler = (e) => {
        setNextVisit(e.target.value);
        console.log(e.target.value);

        if (e.target.value == "After 1 week") {
            console.log("1 week");

            let m_names = new Array("Jan", "Feb", "Mar",
                "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
            let d = new Date();
            d.setDate(d.getDate() + 7);
            let curr_date = d.getDate();
            let curr_month = d.getMonth();
            let curr_year = d.getFullYear();
            const language = 'en-us';
            const options = { weekday: 'long' };
            let nextvisitday = curr_date + "-" + m_names[curr_month] + "-" + curr_year + " - " + d.toLocaleString(language, options);
            console.log(nextvisitday);
            setShowDate(nextvisitday);

        }
        if (e.target.value == "After 2 weeks") {
            console.log("2 weeks");

            let m_names = new Array("Jan", "Feb", "Mar",
                "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
            let d = new Date();
            d.setDate(d.getDate() + 14);
            let curr_date = d.getDate();
            let curr_month = d.getMonth();
            let curr_year = d.getFullYear();
            const language = 'en-us';
            const options = { weekday: 'long' };
            let nextvisitday = curr_date + "-" + m_names[curr_month] + "-" + curr_year + " - " + d.toLocaleString(language, options);
            console.log(nextvisitday);
            setShowDate(nextvisitday);

        }
        if (e.target.value == "After 1 month") {
            console.log("1 month");

            let m_names = new Array("Jan", "Feb", "Mar",
                "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
            let d = new Date();
            d.setDate(d.getDate() + 30);
            let curr_date = d.getDate();
            let curr_month = d.getMonth();
            let curr_year = d.getFullYear();
            const language = 'en-us';
            const options = { weekday: 'long' };
            let nextvisitday = curr_date + "-" + m_names[curr_month] + "-" + curr_year + " - " + d.toLocaleString(language, options);
            console.log(nextvisitday);
            setShowDate(nextvisitday);

        }

        if (e.target.value == "After 3 months") {
            console.log("3 months");

            let m_names = new Array("Jan", "Feb", "Mar",
                "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
            let d = new Date();
            d.setDate(d.getDate() + 90);
            let curr_date = d.getDate();
            let curr_month = d.getMonth();
            let curr_year = d.getFullYear();
            const language = 'en-us';
            const options = { weekday: 'long' };
            let nextvisitday = curr_date + "-" + m_names[curr_month] + "-" + curr_year + " - " + d.toLocaleString(language, options);
            console.log(nextvisitday);
            setShowDate(nextvisitday);

        }
        if (e.target.value == "After 6 months") {
            console.log("6 months");

            let m_names = new Array("Jan", "Feb", "Mar",
                "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
            let d = new Date();
            d.setDate(d.getDate() + 120);
            let curr_date = d.getDate();
            let curr_month = d.getMonth();
            let curr_year = d.getFullYear();
            const language = 'en-us';
            const options = { weekday: 'long' };
            let nextvisitday = curr_date + "-" + m_names[curr_month] + "-" + curr_year + " - " + d.toLocaleString(language, options);
            console.log(nextvisitday);
            setShowDate(nextvisitday);
        }
    }
    useEffect(() => {
        setLoctionObject(location.state.state);
        setPid(location.state.state.patients_id_fk);
        setConsultationId(location.state.state.consultation_id);

        Axios.get(`${global.baseUrl}/api/clinicapi/PatientConsultation/basicinfo?id=${location.state.state.id}`).then((response) => {
            // console.log(response.data[0].visiting_purpose)
            console.log("basic profile", response.data);
            if (response.data.status == '1') {
                setConsultationDate(moment(response.data.response.checkin_date_time).format('DDMMYYYY'));
                setPatientEmail(response.data.response.email);

            }
        });


        Axios.get(`${global.baseUrl}/api/commonapi/PickList/get_prescription_name`).then((response) => {
            console.log(response.data);
            if (response.data.status == '1') {
                setPrecriptionType(response.data.response);
            }
        });

        Axios.get(`${global.baseUrl}/api/clinicapi/PatientConsultation/basicinfo?id=${location.state.state.id}`).then((response) => {
            if (response.data.status == '1') {

                setChief_complaints(response.data.response.visiting_purpose);
            }
        });

        Axios.get(`${global.baseUrl}/api/commonapi/PickList/get_does_advices`).then((response) => {
            console.log("advice does list", response.data);
            if (response.data.status == '1') {
                setAdviceDoesList(response.data.response);
            }


        })
        Axios.get(`${global.baseUrl}/api/commonapi/PickList/get_donts_advices`).then((response) => {
            console.log("advice don'ts list", response.data.response);
            if (response.data.status == '1') {
                setAdviceDontsList(response.data.response);
            }


        })

        Axios.get(`${global.baseUrl}/api/commonapi/PickList/get_services`
        ).then(
            (response) => {

                console.log("service list = ", response.data.response);
                setServiceList(response.data.response);

            }

        ).catch((error) => {
            console.log(error.data);
        });

        Axios.get(`${global.baseUrl}/api/clinicapi/FeeMaster/get_services_list?serviceType=pro&clinicId=${localStorage.getItem("clinic_id")}`).then((response) => {
            console.log(response.data.response);
            if (response.data.response.length > 0) {
                const formattedList = response.data.response?.map((list) => ({
                    value: list.id,
                    label: list.fee_name,
                }))
                setProcedureList(formattedList);


            }
            else {
                setProcedureList([]);

            }

        });

    }, [])


    useEffect(() => {
        //setMicMedicine(false);
        setMedicineSearchHandler(transcript);
    }, [transcript])

    let nextVisitDayList = [

        {
            id: 1,
            key: 'After 1 week',
            value: 'After 1 week',

        },
        {
            id: 2,
            key: 'After 2 weeks',
            value: 'After 2 weeks',

        },
        {
            id: 3,
            key: 'After 1 month',
            value: 'After 1 month',

        },
        {
            id: 4,
            key: 'After 3 months',
            value: 'After 3 months',

        },
        {
            id: 5,
            key: 'After 6 months',
            value: 'After 6 months',

        },
    ]

    const cancelConsultation = (e) => {
        e.preventDefault();
        setCancelling(true);


        Axios.get(`${global.baseUrl}/api/clinicapi/ConsultationCheckup/cancel_consultation?consultation_id=${location.state.state.id}`).then((response) => {
            console.log("data", response.data);
            if (response.data.status == '1') {
                if (response.data.response) {
                    setCancelling(false);
                    navigate("/Consultation");
                }
            }

        })

    }
    const chiefComplaintsHandler = (e) => {

        setChief_complaints(e.target.value);

    }

    let array_data;
    const onValUpdate = (i, event) => {
        const { name, value } = event.target;
        const data = [...medicineTableRows];
        data[i][name] = value;
        console.log("data array, ", data);
        console.log("index, ", data[i]);
        // console.log("medicine, ", data[i].medicine);
        setMedicineTableRows(data);
        array_data = [JSON.stringify(data)];
        setMedicineTableArray(array_data);
    };
    const tableRowRemove = (index) => {
        const dataRow = [...medicineTableRows];
        dataRow.splice(index, 1);
        setMedicineTableRows(dataRow);
    };

    const addRowTable = () => {

        const data = {
            name: "",
            dose: "",
            when: "",
            frequency: "",
            duration: ""
        };
        setMedicineTableRows([...medicineTableRows, data]);
    };

    // const rightEyePowerData = {
    //     dsph: "",
    //     dcyl: "",
    //     axix: "",
    //     vision: ""
    // }
    // setEyePowerTableRows([...eyePowerTableRows, rightEyePowerData]);
    let eyeArray_data_distance;

    const onValEyePowerUpdate = (i, event) => {
        const { name, value } = event.target;
        const eyepowerdata = [...eyePowerTableRows];
        eyepowerdata[i][name] = value;
        console.log("eye power data array, ", eyepowerdata);
        console.log("eye power  index, ", eyepowerdata[i]);
        // console.log("medicine, ", data[i].medicine);
        setEyePowerTableRows(eyepowerdata);
        eyeArray_data_distance = [JSON.stringify(eyepowerdata)];
        setEyePowerTableArray(eyeArray_data_distance);
    };


    const addRowTableWithData = (medName, medDose, medFreq) => {

        const data = {
            name: medName,
            dose: medDose,
            when: "",
            frequency: "",
            duration: medFreq
        };
        setMedicineTableRows([...medicineTableRows, data]);
        // const value = [...medicineTableRows];

        array_data = [JSON.stringify([...medicineTableRows, data])];
        setMedicineTableArray(array_data);
    };

    function startListening() {
        setMicLab(true);
        SpeechRecognition.stopListening();

        recognitionL.interimResults = true;
        recognitionL.continuous = true;

        recognitionL.start();
        setTimeout(() => {
            recognitionL.stop()
            setMicLab(false)
            console.log("Stop")

        }, 3500);


    }

    function startListeningMedicine() {

        // if (listeningMedicine) {
        //     setMicMedicine(false)
        //     SpeechRecognition.stopListening()
        // } else {
        //     setMicMedicine(true)
        //     SpeechRecognition.startListening()
        // }

        setMicMedicine(true);
        recognitionL.stop()
        SpeechRecognition.startListening()
        setTimeout(() => {
            SpeechRecognition.stopListening()
            setMicMedicine(false)
        }, 5000);

    }

    const onAdviceDontsUpdate = (e) => {
        adviceDontsCount.current = adviceDontsCount.current + 1
        const old = adviceDonts
        setInvestigationSearch('')
        setAdviceDonts(old + adviceDontsCount.current + ':) ' + e.target.value + '\n')
    }


    const completeWithAudioHandler = (e) => {

        e.preventDefault();
        if (selectedProcedure.length > 0) {
            let formdata = $(e.target);
            formdata = new FormData();
            formdata.append('clinic_id', localStorage.getItem("clinic_id"));
            formdata.append('array_data', JSON.stringify(selectedProcedure));
            formdata.append('consultation_id_fk', location.state.state.id);

            $.ajax({
                type: "POST",
                url: `${global.baseUrl}/api/clinicapi/FeeMaster/add_pro_consultation_service`,
                data: formdata,
                processData: false,
                contentType: false,
                success(data) {
                    console.log("service data=  ", data);

                },
                error: function (err) {
                    console.log(err.responseText);
                    alert("error has occured  ", err);
                }
            });
        }
        let formdata = $(e.target);
        formdata = new FormData();
        formdata.append("file", audioFile);
        formdata.append('constid', location.state.state.id);
        formdata.append('clinicid', localStorage.getItem("clinic_id"));
        $.ajax({
            type: "POST",
            url: `${global.baseUrl}/api/commonapi/FileUpload/audio_file_insert_emr`,
            data: formdata,
            processData: false,
            contentType: false,
            success(data) {
                console.log(data);
                setIsButtonHide(true);
                e.preventDefault();
                setShowPleaseWait(true);
                let formdata = $(e.target);
                formdata = new FormData();
                formdata.append('prescription_id_fk', "3");
                formdata.append('chief_complaints', chief_complaints);
                formdata.append('doctor_findings', doctor_notes);
                formdata.append('notes', notes);
                formdata.append('doctor_investigation', testMed);
                formdata.append('medicine', medicineTableArray);
                formdata.append('eye_power', eyePowerTableArray);
                formdata.append('advice_does', adviceDoes);
                formdata.append('advice_donts', adviceDonts);
                formdata.append('next_visit', showDate);
                if (chief_complaints && doctor_notes && testMed && medName != "") {
                    formdata.append('isdigital_prescription', "1");
                }
                else {
                    formdata.append('isdigital_prescription', "0");
                }

                formdata.append('id', consultationId);
                formdata.append('patients_id_fk', pid);
                formdata.append('audio', data);
                if (selectedProcedure.length > 0) {
                    formdata.append('clinic_procedure', JSON.stringify(procedure));
                }
                $.ajax({
                    type: "POST",
                    url: `${global.baseUrl}/api/clinicapi/ConsultationCheckup/complete_consultation`,
                    data: formdata,
                    processData: false,
                    contentType: false,
                    success(data) {
                        console.log(data);
                        if (pid != '0') {
                            let formdata = $(e.target);
                            formdata = new FormData();
                            formdata.append('consultation_id', location.state.state.id);
                            formdata.append('patient_name', location.state.state.name);
                            formdata.append('doctors_id', docId);
                            formdata.append('clinic_id', localStorage.getItem("clinic_id"));
                            $.ajax({
                                type: "POST",
                                url: `${global.baseUrl}/api/clinicapi/Feedback/create_feedback`,
                                data: formdata,
                                processData: false,
                                contentType: false,
                                success(feedbackId) {
                                    console.log(feedbackId);
                                    const datafile = new FormData();
                                    datafile.append("email_id", patientemail);
                                    datafile.append("subject", " Healthconnectpro Feedback");
                                    let base64encodedParams = `${feedbackId.response}&${docId}&${ConsultationDate}`;
                                    let url = `${window.location.host}/UGF0aWVudEZlZWRiYWNr/${base64_encode(base64encodedParams)}`;
                                    console.log("url", url);
                                    datafile.append("message", `${url}`);
                                    $.ajax({
                                        type: "POST",
                                        url: `${global.baseUrl}/api/clinicapi/SendMail/send_mail_basic`,
                                        data: datafile,
                                        processData: false,
                                        contentType: false,
                                        success(data) {
                                            console.log("emailSendHandler:: msg sent  ", data);

                                            Axios.get(`${global.baseUrl}/api/clinicapi/ConsultationCheckup/get_AI_consultationId?constId=${location.state.state.consultation_id}`).then((response) => {
                                                console.log(response.data);
                                                if (response.data.status == '1') {
                                                    setShowPleaseWait(false);

                                                    setMsg("Consultation Complete")
                                                    setTimeout(() => {
                                                        navigate("/SelfCheckout", { state: response.data.response.id })
                                                    }, 2000)
                                                }


                                            })

                                        },
                                        error: function (err) {
                                            console.log(err.responseText);
                                            alert("error has occured  ", err);
                                        }
                                    });

                                },
                                error: function (err) {
                                    console.log(err);
                                    alert("Feedback creation failed ", err);

                                }
                            });
                        }
                        else {
                            Axios.get(`${global.baseUrl}/api/clinicapi/ConsultationCheckup/get_AI_consultationId?constId=${location.state.state.consultation_id}`).then((response) => {
                                console.log(response.data);
                                if (response.data.status == '1') {
                                    setShowPleaseWait(false);

                                    setMsg("Consultation Complete")
                                    setTimeout(() => {
                                        navigate("/SelfCheckout", { state: response.data.response.id })
                                    }, 2000)
                                }


                            })
                        }

                    },
                    error: function (err) {
                        console.log(err.responseText);
                        setIsButtonHide(false);
                        setShowPleaseWait(false);
                        alert("error has occured  ", err.responseText);
                    }
                });
            },
            error: function (err) {
                console.log(err);

            }
        });
    }

    const completeHandler = (e) => {


        e.preventDefault();
        if (selectedProcedure.length > 0) {
            let formdata = $(e.target);
            formdata = new FormData();
            formdata.append('clinic_id', localStorage.getItem("clinic_id"));
            formdata.append('array_data', JSON.stringify(selectedProcedure));
            formdata.append('consultation_id_fk', location.state.state.id);

            $.ajax({
                type: "POST",
                url: `${global.baseUrl}/api/clinicapi/FeeMaster/add_pro_consultation_service`,
                data: formdata,
                processData: false,
                contentType: false,
                success(data) {
                    console.log("service data=  ", data);

                },
                error: function (err) {
                    console.log(err.responseText);
                    alert("error has occured  ", err);
                }
            });
        }
        console.log(medicineTableArray);

        setIsButtonHide(true);
        e.preventDefault();
        setShowPleaseWait(true);
        let formdata = $(e.target);
        formdata = new FormData();
        formdata.append('prescription_id_fk', "3");
        formdata.append('chief_complaints', chief_complaints);
        formdata.append('doctor_findings', doctor_notes);
        formdata.append('notes', notes);
        formdata.append('doctor_investigation', testMed);
        formdata.append('medicine', medicineTableArray);
        formdata.append('eye_power', eyePowerTableArray);
        formdata.append('advice_does', adviceDoes);
        formdata.append('advice_donts', adviceDonts);
        formdata.append('next_visit', showDate);
        if (chief_complaints && doctor_notes && testMed && medName != "") {
            formdata.append('isdigital_prescription', "1");
        }
        else {
            formdata.append('isdigital_prescription', "0");
        }

        formdata.append('id', consultationId);
        formdata.append('patients_id_fk', pid);
        formdata.append('audio', audioName);
        if (selectedProcedure.length > 0) {
            formdata.append('clinic_procedure', JSON.stringify(procedure));
        }
        $.ajax({
            type: "POST",
            url: `${global.baseUrl}/api/clinicapi/ConsultationCheckup/complete_consultation`,
            data: formdata,
            processData: false,
            contentType: false,
            success(data) {
                console.log(data);
                if (pid != '0') {
                    let formdata = $(e.target);
                    formdata = new FormData();
                    formdata.append('consultation_id', location.state.state.id);
                    formdata.append('patient_name', location.state.state.name);
                    formdata.append('doctors_id', docId);
                    formdata.append('clinic_id', localStorage.getItem("clinic_id"));
                    $.ajax({
                        type: "POST",
                        url: `${global.baseUrl}/api/clinicapi/Feedback/create_feedback`,
                        data: formdata,
                        processData: false,
                        contentType: false,
                        success(feedbackId) {
                            console.log(feedbackId);
                            const datafile = new FormData();
                            datafile.append("email_id", patientemail);
                            datafile.append("subject", " Healthconnectpro Feedback");
                            let base64encodedParams = `${feedbackId.response}&${docId}&${ConsultationDate}`;
                            let url = `${window.location.host}/UGF0aWVudEZlZWRiYWNr/${base64_encode(base64encodedParams)}`;
                            console.log("url", url);
                            datafile.append("message", `${url}`);
                            $.ajax({
                                type: "POST",
                                url: `${global.baseUrl}/api/clinicapi/SendMail/send_mail_basic`,
                                data: datafile,
                                processData: false,
                                contentType: false,
                                success(data) {
                                    console.log("emailSendHandler:: msg sent  ", data);

                                    Axios.get(`${global.baseUrl}/api/clinicapi/ConsultationCheckup/get_AI_consultationId?constId=${location.state.state.consultation_id}`).then((response) => {
                                        console.log(response.data);
                                        if (response.data.status == '1') {
                                            setShowPleaseWait(false);

                                            setMsg("Consultation Complete")
                                            setTimeout(() => {
                                                navigate("/SelfCheckout", { state: response.data.response.id })
                                            }, 2000)
                                        }


                                    })

                                },
                                error: function (err) {
                                    console.log(err.responseText);
                                    alert("error has occured  ", err);
                                }
                            });

                        },
                        error: function (err) {
                            console.log(err);
                            alert("Feedback creation failed ", err);

                        }
                    });
                }
                else {
                    Axios.get(`${global.baseUrl}/api/clinicapi/ConsultationCheckup/get_AI_consultationId?constId=${location.state.state.consultation_id}`).then((response) => {
                        console.log(response.data);
                        if (response.data.status == '1') {
                            setShowPleaseWait(false);

                            setMsg("Consultation Complete")
                            setTimeout(() => {
                                navigate("/SelfCheckout", { state: response.data.response.id })
                            }, 2000)
                        }


                    })
                }

            },
            error: function (err) {
                console.log(err.responseText);
                setIsButtonHide(false);
                setShowPleaseWait(false);
                alert("error has occured  ", err.responseText);
            }
        });

    }

    const handleCloseConsultation = (e) => {
        setConsultationModalOpen(false);
    }

    const handleCloseForward = (event) => {
        setForwardModalOpen(false);

    }

    const audioChunk = useRef([]);
    const [recording, setRecording] = useState("");
    const mediaRecorderRef = useRef(null);
    const [audioFile, setAudioFile] = useState("");
    const [audioRecordStart, setAudioRecordStart] = useState(false);
    const [audioName, setAudioName] = useState("");
    const startRec = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true })

            const mediaRecorder = new MediaRecorder(stream);
            mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    audioChunk.current.push(event.data);
                };
            };
            mediaRecorder.onstop = () => {
                const audioBlob = new Blob(audioChunk.current, { type: 'audio/mp3' });
                const audiofile = new File([audioBlob], "audiofile.mp3", {
                    type: "audio/mpeg",
                });
                setAudioFile(audiofile);
                console.log(audiofile);
                const audioUrl = URL.createObjectURL(audiofile);
                console.log(audioUrl)
                setRecording(audioUrl);
            };
            mediaRecorderRef.current = mediaRecorder;
            mediaRecorder.start();
            setAudioRecordStart(true);
        }
        catch (error) { console.error('Error accessing microphone:', error) };

    };

    const stopRec = () => {
        setAudioRecordStart(false)
        if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
            mediaRecorderRef.current.stop();
        }
    }

    const audioUploadHandeler = (e) => {
        e.preventDefault();
        let formdata = $(e.target);
        formdata = new FormData();
        formdata.append("file", audioFile);
        formdata.append('constid', location.state.state.id);
        formdata.append('clinicid', localStorage.getItem("clinic_id"));
        $.ajax({
            type: "POST",
            url: `${global.baseUrl}/api/commonapi/FileUpload/audio_file_insert_emr`,
            data: formdata,
            processData: false,
            contentType: false,
            success(data) {
                console.log(data);
                setAudioName(data);
            },
            error: function (err) {
                console.log(err);

            }
        });
    }
    return (
        <>
            <div className="topbar-wrap">
                <Header />

            </div>
            {/* <div style={{ marginTop: -15 }}>
                <CustomTopNavbarButton />
            </div> */}
            <div style={{ marginTop: -20, marginBottom: 20 }} className="page-content">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-4">
                            <div style={{ textAlign: 'left' }}>
                                <button className="btn btn-auto btn-primary" onClick={() => { navigate(-1) }}  ><img src={back} style={{ height: 20, width: 20 }} /></button>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4">
                            <h6 className="card-title">Consultation</h6>
                        </div>
                        <div className="col-xl-4 col-lg-4">

                        </div>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: -5 }} className="page-content">
                <div className="container">
                    <div className="row">
                        <div className="main-content col-lg-12">
                            <div className="content-area card">
                                <div className="card-innr">
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <p className="card-title"> {location.state.state?.name} &nbsp;(&nbsp;{location.state.state.gender} {location.state.state.age} )</p>

                                    </div>

                                    <div style={{ marginTop: 20 }} className="row">
                                        <div className="col-md-6">
                                            <p style={{ textAlign: 'left', color: '#5A8AFF' }} className="label">Chief Complaints:</p>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', marginTop: 15 }}>

                                                <textarea style={{ height: 120, fontSize: 14, fontWeight: '500', color: 'black' }} className="input-bordered input-textarea"
                                                    value={chief_complaints} name="chief_complaints" onChange={(e) => chiefComplaintsHandler(e)}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <p style={{ textAlign: 'left', color: '#5A8AFF' }} className="label">Record Audio:</p>
                                            <div className="row">
                                                {
                                                    audioRecordStart == false ?
                                                        <p type="submit" onClick={startRec} style={{ marginLeft: 150, color: 'blue', cursor: 'pointer', fontSize: 18 }}  >Start </p>
                                                        : <p type="submit" onClick={stopRec} style={{ marginLeft: 150, color: 'red', cursor: 'pointer', fontSize: 18 }}  >Stop </p>
                                                }

                                                {
                                                    audioFile ?
                                                        <p onClick={audioUploadHandeler} style={{ marginLeft: 170, color: 'green', cursor: 'pointer', fontSize: 18 }}>
                                                            Upload
                                                        </p> : null
                                                }
                                            </div>

                                            <div style={{ marginTop: 10 }}>
                                                {recording ?
                                                    <>
                                                        <audio src={recording} style={{ marginLeft: 30, border: 2 }} controls />
                                                    </>

                                                    : <audio src={recording} style={{ marginLeft: 30, border: 2 }} controls />

                                                }
                                            </div>


                                        </div>
                                    </div>
                                    <div style={{ marginTop: 20 }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', border: '1px solid black', height: 30 }}>
                                            <div style={{ width: '50%' }}>
                                                <p style={{ color: 'black', fontSize: 14, fontWeight: 'bold' }}>RIGHT EYE (OD)</p>

                                            </div>
                                            <div style={{ width: '50%' }}>
                                                <p style={{ color: 'black', fontSize: 14, fontWeight: 'bold' }}>LEFT EYE (OS)</p>

                                            </div>

                                        </div>

                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>

                                        <div style={{ width: '100%' }}>
                                            <table id="eyeprescription">

                                                <thead>
                                                    <tr>
                                                        <th style={{ textAlign: "center", }}></th>
                                                        <th style={{ textAlign: "center", }}>D.SPH.</th>

                                                        <th style={{ textAlign: "center", }}>D.CYL</th>
                                                        <th style={{ textAlign: "center", }}>AXIS</th>
                                                        <th style={{ textAlign: "center", }}>VISION</th>
                                                        <th style={{ textAlign: "center", }}>D.SPH.</th>

                                                        <th style={{ textAlign: "center", }}>D.CYL</th>
                                                        <th style={{ textAlign: "center", }}>AXIS</th>
                                                        <th style={{ textAlign: "center", }}>VISION</th>

                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    <TableRowsEyePower
                                                        rows={eyePowerTableRows}
                                                        // rows1={eyePowerTableRows1}
                                                        onValEyePowerUpdate={onValEyePowerUpdate}
                                                    />


                                                </tbody>

                                            </table>
                                        </div>


                                    </div>



                                    <div style={{ marginTop: 10 }} className="row">
                                        <div className="col-md-6">
                                            <div style={{ display: 'flex', flexDirection: 'row' }}>

                                                <p style={{ textAlign: 'left', color: '#5A8AFF' }} className="label"> Observations: </p>
                                                <p style={{ textAlign: 'left', color: 'green', marginLeft: 15 }} className="label">RE: </p>
                                            </div>


                                            <textarea style={{ height: 120, marginTop: 10, fontSize: 14, fontWeight: '500', color: 'black', borderColor: '#90EE90' }} className="input-bordered input-textarea"
                                            // value={adviceDoes} name="adviceDoes" onChange={(e) => adviceDoesHandler(e)}

                                            />

                                        </div>
                                        <div className="col-md-6">
                                            <div style={{ display: 'flex', flexDirection: 'row' }}>

                                                <p style={{ textAlign: 'left', color: '#5A8AFF' }} className="label"> Observations: </p>
                                                <p style={{ textAlign: 'left', color: 'green', marginLeft: 15 }} className="label"> LE: </p>
                                            </div>
                                            <textarea style={{ height: 120, marginTop: 10, fontSize: 14, fontWeight: '500', color: 'black', borderColor: '#90EE90' }} className="input-bordered input-textarea"
                                            // value={adviceDonts} name="adviceDonts" onChange={(e) => adviceDontsHandler(e)}

                                            />

                                        </div>
                                    </div>




                                    <div style={{ marginTop: 30 }}  >
                                        <p style={{ textAlign: 'left', color: '#5A8AFF' }} className="label">Medicine:</p>

                                        <table id="medicinetable" style={{ width: '100%', paddingRight: 5, borderRadius: 5, marginTop: 20 }} >
                                            <tr>
                                                <th style={{ width: '20%', textAlign: 'center', paddingLeft: 5 }}>Medicine Name</th>
                                                <th style={{ textAlign: 'center', width: '22%' }}>Dose</th>
                                                <th style={{ textAlign: 'center', width: '20%' }}>When / How</th>
                                                <th style={{ textAlign: 'center', width: '20%' }}>Frequency</th>
                                                <th style={{ textAlign: 'center', width: '22%' }}>Duration</th>

                                            </tr>
                                        </table>
                                    </div>
                                    <div className="page-content">
                                        <div className="container">
                                            <div >
                                                <table className="table table-striped" >
                                                    <thead>
                                                    </thead>
                                                    <tbody >

                                                        <TableRows
                                                            rows={medicineTableRows}
                                                            tableRowRemove={tableRowRemove}
                                                            onValUpdate={onValUpdate}
                                                        />

                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td colspan="5"></td>
                                                            <td style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }} >
                                                                <button style={{ fontSize: 20, marginTop: 5 }} className="btn btn-auto btn-xs btn-success" onClick={addRowTable}>
                                                                    +</button>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 20, flexDirection: 'row' }}>
                                        <input style={{ height: 50, width: '95%', fontSize: 14, fontWeight: '500', color: 'black' }} className="input-bordered input-textarea" placeholder="Search Medicine "
                                            value={medicalSearch} name="testMed" onChange={(e) => setMedicineSearchHandler(e.target.value)}
                                        />
                                    </div>
                                    <div
                                        onClick={() => {
                                            startListeningMedicine()

                                        }}
                                        style={{ display: 'flex', justifyContent: 'flex-end', marginTop: -40 }}>
                                        {
                                            <Mic style={{ color: micMedicine ? 'blue' : 'gray', cursor: 'pointer', fontSize: 30 }} />

                                        }
                                    </div>

                                    <div style={{
                                        display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
                                        margin: '4px',
                                        marginTop: '20px',
                                        overflowY: 'scroll',
                                        overflowX: 'hidden',
                                        maxHeight: '120px',
                                        boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
                                    }}>
                                        {
                                            suggestionList.map((val, key) => {
                                                return (
                                                    <div
                                                        onClick={() => {
                                                            addRowTableWithData(val.name, val.dose, val.duration)
                                                            // medicalCount.current = medicalCount.current + 1
                                                            // setMedicalSearch('')
                                                            // + '\t\t' + val.dose + '\t\t' + val.duration + '\n' + val.composition + '\n'

                                                        }}
                                                        key={key}
                                                        style={{
                                                            width: '99%', margin: '4px',
                                                            padding: '4px', borderRadius: '4px', textAlign: 'start', cursor: 'pointer'
                                                        }}>
                                                        <p>{val.name}</p>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>

                                    <div style={{ marginTop: 10 }} className="row">
                                        <div className="col-md-6">
                                            <p style={{ textAlign: 'left', color: '#5A8AFF' }} className="label"> Diagnostic/Lab Investigation: </p>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', marginTop: 15 }}>


                                                <textarea style={{ height: 120, fontSize: 14, fontWeight: '500', color: 'black' }} className="input-bordered input-textarea"
                                                    value={testMed}
                                                    name="testMed" onChange={(e) => testMedHandler(e)}
                                                />
                                            </div>

                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 20 }}>

                                                <input style={{ height: 50, fontSize: 14, fontWeight: '500', color: 'black' }} className="input-bordered input-textarea" placeholder="Search Diagnostic "
                                                    value={investigationSearch} name="testMed" onChange={(e) => setInvestigationHandler(e.target.value)}
                                                />
                                                <div onClick={() => {
                                                    startListening()
                                                }}>
                                                    <Mic style={{ color: micLab ? 'blue' : 'gray', cursor: 'pointer', marginLeft: 5, fontSize: 30 }} />
                                                </div>
                                            </div>

                                            <div style={{
                                                display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
                                                alignItems: 'flex-start',
                                                margin: '4px',
                                                marginTop: '20px',
                                                overflowY: 'scroll',
                                                overflowX: 'hidden',
                                                maxHeight: '120px',
                                                boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
                                            }}>
                                                {
                                                    investigationList.map((val, key) => {
                                                        return (
                                                            <div
                                                                onClick={() => {
                                                                    investigationCount.current = investigationCount.current + 1
                                                                    const old = testMed
                                                                    setInvestigationSearch('')
                                                                    setTestMed(old + investigationCount.current + ':) ' + val.name + '\n')
                                                                    setInvestigationList([])
                                                                }}
                                                                key={key}
                                                                style={{
                                                                    width: '99%', margin: '4px',
                                                                    padding: '4px', borderRadius: '4px', textAlign: 'start', cursor: 'pointer'
                                                                }}>
                                                                <p>{val.name}</p>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                <p style={{ textAlign: 'left', color: '#5A8AFF' }} className="label"> Clinic Procedure: </p>
                                            </div>

                                            <div style={{ marginTop: 15, }}>

                                                <div style={{ marginTop: 15, }}>
                                                    <Select
                                                        options={procedureList}
                                                        onChange={handleChangeProcedureList}
                                                        isMulti={true}
                                                        value={selectedProcedure}
                                                    />

                                                </div>
                                            </div>



                                        </div>
                                    </div>

                                    <div style={{ marginTop: 10 }} className="row">
                                        <div className="col-md-6">
                                            <div style={{ display: 'flex', flexDirection: 'row' }}>

                                                <p style={{ textAlign: 'left', color: '#5A8AFF' }} className="label"> Advice: </p>
                                                <p style={{ textAlign: 'left', color: 'green', marginLeft: 15 }} className="label"> Do's: </p>
                                            </div>


                                            <textarea style={{ height: 120, marginTop: 10, fontSize: 14, fontWeight: '500', color: 'black', borderColor: '#90EE90' }} className="input-bordered input-textarea"
                                                value={adviceDoes} name="adviceDoes" onChange={(e) => adviceDoesHandler(e)}

                                            />

                                        </div>
                                        <div className="col-md-6">
                                            <div style={{ display: 'flex', flexDirection: 'row' }}>

                                                <p style={{ textAlign: 'left', color: '#5A8AFF' }} className="label"> Advice: </p>
                                                <p style={{ textAlign: 'left', color: 'red', marginLeft: 15 }} className="label">  Don'ts: </p>
                                            </div>
                                            <textarea style={{ height: 120, marginTop: 10, fontSize: 14, fontWeight: '500', color: 'black', borderColor: '#FE7275' }} className="input-bordered input-textarea"
                                                value={adviceDonts} name="adviceDonts" onChange={(e) => adviceDontsHandler(e)}

                                            />

                                        </div>
                                    </div>

                                    <div style={{ marginTop: 20 }} className="row">
                                        <div className="col-md-6">
                                            <div className="select-wrapper">
                                                <select className="input-bordered"
                                                    // name="docid"
                                                    // value={docid}
                                                    onChange={(event) => onAdviceDoesUpdate(event)}

                                                >
                                                    <option value="">Select</option>
                                                    {adviceDoesList.map((list) => {
                                                        return (
                                                            <>
                                                                <option value={list.value} >{list.value}</option>

                                                            </>
                                                        );
                                                    })}

                                                </select>

                                            </div>

                                        </div>
                                        <div className="col-md-6">

                                            <div className="select-wrapper">
                                                <select className="input-bordered"

                                                    // name="docid"
                                                    // value={docid}
                                                    onChange={(event) => onAdviceDontsUpdate(event)}
                                                >
                                                    <option value="">Select</option>
                                                    {adviceDontsList.map((list) => {
                                                        return (
                                                            <>
                                                                <option value={list.value} >{list.value}</option>
                                                            </>
                                                        );
                                                    })}

                                                </select>

                                            </div>
                                        </div>
                                    </div>




                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <p style={{ textAlign: 'left', marginTop: 18 }} className="label">  Next Visit: </p>

                                    </div>


                                    <div >
                                        {
                                            audioFile ?
                                                <Dialog
                                                    open={consultationModalOpen}
                                                    onClose={handleCloseConsultation}
                                                    aria-labelledby="alert-dialog-title"
                                                    aria-describedby="alert-dialog-description"
                                                >
                                                    <DialogTitle id="alert-dialog-title">
                                                        {"Do you want to upload audio with complete consultation ?"}

                                                    </DialogTitle>
                                                    <DialogContent>
                                                        <DialogContentText id="alert-dialog-description">

                                                        </DialogContentText>
                                                    </DialogContent>
                                                    <DialogActions>

                                                        {isButtonHide == false ?
                                                            <form
                                                                method="post"
                                                                onSubmit={(event) => completeWithAudioHandler(event)}
                                                            >
                                                                <Button type="submit" autoFocus>
                                                                    Yes
                                                                </Button>
                                                            </form>
                                                            :
                                                            null
                                                        }
                                                        {isButtonHide == false ?
                                                            <form
                                                                method="post"
                                                                onSubmit={(event) => completeHandler(event)}
                                                            >
                                                                <Button type="submit" autoFocus>
                                                                    No
                                                                </Button>
                                                            </form>
                                                            :
                                                            null
                                                        }

                                                    </DialogActions>
                                                </Dialog>
                                                :
                                                <Dialog
                                                    open={consultationModalOpen}
                                                    onClose={handleCloseConsultation}
                                                    aria-labelledby="alert-dialog-title"
                                                    aria-describedby="alert-dialog-description"
                                                >
                                                    <DialogTitle id="alert-dialog-title">
                                                        {"Are you sure you want to complete consultation?"}
                                                    </DialogTitle>
                                                    <DialogContent>
                                                        <DialogContentText id="alert-dialog-description">

                                                        </DialogContentText>
                                                    </DialogContent>
                                                    <DialogActions>
                                                        {msg && <p style={{ fontSize: 18, fontWeight: 'bold', marginTop: 10, color: 'green', marginLeft: 'auto', marginRight: 'auto' }}>{msg}</p>}


                                                        {
                                                            isButtonHide == false ?

                                                                <Button onClick={handleCloseConsultation}>Cancel</Button>


                                                                :
                                                                null
                                                        }
                                                        {
                                                            isButtonHide == false ?
                                                                <form
                                                                    method="post"
                                                                    onSubmit={(event) => completeHandler(event)}
                                                                >
                                                                    <Button type="submit" autoFocus>
                                                                        Complete
                                                                    </Button>
                                                                </form>
                                                                :
                                                                null

                                                        }

                                                        {
                                                            showPleaseWait ?
                                                                <div  >
                                                                    <p style={{ fontSize: 14, fontWeight: 'bold', color: 'blue' }}>Please wait...</p>
                                                                </div>
                                                                :
                                                                null
                                                        }

                                                    </DialogActions>
                                                </Dialog>
                                        }
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div style={{ width: '39%' }}>

                                            <div className="select-wrapper" style={{ marginTop: 10 }}>
                                                <select className="input-bordered"
                                                    name="nextVisit"
                                                    value={nextVisit}
                                                    onChange={(event) => nextVisitHandler(event)}
                                                >
                                                    <option value="">Select</option>
                                                    {nextVisitDayList.map((list) => {
                                                        return (
                                                            <>
                                                                <option value={list.value} >{list.value}</option>

                                                            </>
                                                        );
                                                    })}

                                                </select>

                                            </div>
                                        </div>

                                        <div style={{ width: '60%' }}>
                                            <p style={{ textAlign: 'left', marginTop: 15, fontSize: 16, marginLeft: 10 }} className="value">{showDate} </p>
                                        </div>


                                        <div style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: 10 }}>

                                            <div className="flex-div">
                                                {cancelling ? <p style={{ fontSize: 13, fontWeight: 'bold', color: 'red', marginTop: 5 }}>Cancelling please wait...</p> :

                                                    <button onClick={() => setCancelConsultationModalOpen(true)} type="submit" className="btn btn-auto   btn-danger" style={{ marginLeft: 10 }}  >Cancel</button>

                                                }



                                                <div >
                                                    <Dialog
                                                        open={cancelConsultationModalOpen}
                                                        onClose={handleCloseCancelConsultation}
                                                        aria-labelledby="alert-dialog-title"
                                                        aria-describedby="alert-dialog-description"
                                                    >
                                                        <DialogTitle id="alert-dialog-title">
                                                            {"Are you sure you want to cancel consultation?"}
                                                        </DialogTitle>
                                                        <DialogContent>
                                                            <DialogContentText id="alert-dialog-description">

                                                            </DialogContentText>
                                                        </DialogContent>
                                                        <DialogActions>


                                                            {
                                                                isButtonHide == false ?

                                                                    <Button onClick={handleCloseCancelConsultation}>No</Button>


                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                isButtonHide == false ?
                                                                    <form
                                                                        method="post"
                                                                        onSubmit={(event) => cancelConsultation(event)}
                                                                    >
                                                                        <Button type="submit" autoFocus>
                                                                            Yes
                                                                        </Button>
                                                                    </form>
                                                                    :
                                                                    null

                                                            }



                                                        </DialogActions>
                                                    </Dialog>

                                                </div>

                                                <div  >
                                                    <Dialog
                                                        open={forwardModalOpen}
                                                        onClose={handleCloseForward}
                                                        aria-labelledby="alert-dialog-title"
                                                        aria-describedby="alert-dialog-description"
                                                    >
                                                        <DialogTitle style={{ color: 'black' }} id="alert-dialog-title">
                                                            {/* {"Are you sure you want to cancel consultation?"} */}
                                                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>

                                                                Forward patients to further procedure

                                                                <Button onClick={handleCloseForward} style={{ marginLeft: 30 }} >Close</Button>

                                                            </div>


                                                        </DialogTitle>
                                                        <DialogContent style={{ height: 250 }}
                                                        >
                                                            <DialogContentText id="alert-dialog-description">

                                                            </DialogContentText>
                                                            <div>
                                                                <p className="label">Select service type:</p>

                                                            </div>



                                                            <div style={{ width: '100%', marginTop: 7 }} className="select-wrapper">
                                                                <select className="input-bordered"
                                                                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid #CED4DA' }}
                                                                    name="servicetype"
                                                                    value={servicetype}
                                                                    onChange={(event) => serviceTypeUpdateHandler(event)}
                                                                >
                                                                    <option value="" >Select</option>

                                                                    {serviceList.map((list) => {
                                                                        return (
                                                                            <>
                                                                                <option value={list.code} >{list.name}</option>
                                                                            </>
                                                                        );
                                                                    })}

                                                                </select>

                                                            </div>

                                                            {isChooseServiceType ?
                                                                <>
                                                                    <div style={{ marginTop: 10 }}>
                                                                        <p className="label">Select service:</p>

                                                                    </div>

                                                                    {isShowServiceDropDown ?
                                                                        <>


                                                                            <div style={{ width: '100%', marginTop: 7 }} className="select-wrapper">
                                                                                <select className="input-bordered"
                                                                                    style={{ backgroundColor: 'white', color: 'black', border: '1px solid #CED4DA' }}
                                                                                    name="consultService"
                                                                                    value={consultService}
                                                                                    onChange={(event) => serviceUpdateHandler(event)}
                                                                                >
                                                                                    <option value="" >Select</option>

                                                                                    {ConsultationServiceList.map((list) => {
                                                                                        return (
                                                                                            <>
                                                                                                <option value={list.id} >{list.fee_name}</option>
                                                                                            </>
                                                                                        );
                                                                                    })}

                                                                                </select>

                                                                            </div>

                                                                        </>
                                                                        :
                                                                        <p style={{ textAlign: 'left', fontSize: 16, fontWeight: 'bold', color: 'red' }}>No services found for this service type.</p>
                                                                    }



                                                                    <form
                                                                        method="post"
                                                                        onSubmit={(event) => addServiceHandler(event)}
                                                                    >

                                                                        <button style={{ marginTop: 20, marginLeft: 'auto', marginRight: 'auto' }} type="submit" className="btn btn-auto   btn-success"   >Add Service</button>
                                                                    </form>


                                                                </> : null
                                                            }




                                                        </DialogContent>
                                                        <DialogActions>








                                                        </DialogActions>
                                                    </Dialog>

                                                </div>

                                                <button onClick={() => setConsultationModalOpen(true)} type="submit" className="btn btn-auto   btn-success" style={{ marginLeft: 15 }}  >Complete </button>
                                                <button onClick={() => setForwardModalOpen(true)} type="submit" className="btn btn-auto btn-warning" style={{ marginLeft: 15 }}  >Forward </button>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}